export const ADD_TO_BASKET = 'ADD_TO_BASKET';
export const CLEAR_BASKET = 'CLEAR_BASKET';
export const REMOVE_ITEM_FROM_BASKET = 'REMOVE_ITEM_FROM_BASKET';
export const SET_SHOP = 'SET_SHOP';
export const SET_USER_BASKET = 'SET_USER_BASKET';
export const TOGGLE_MOBILE_ADD_TO_BASKET = 'TOGGLE_MOBILE_ADD_TO_BASKET';
export const SET_BASKET_CONFLICT = 'SET_BASKET_CONFLICT';
export const SET_IS_COLLECTION = 'SET_IS_COLLECTION';